import { useState } from "react"
import { Button, makeStyles, Typography } from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons"

import AddPlaceDialog from "../AddPlaceDialog"
import useSafetyPlanOptionStyles from "./useSafetyPlanOptionStyles"
import { OptionProps, Selected } from "../../../../utils/safetyPlanUtils"
import { colors } from "../../../../utils/theme"

export default function PlaceOption({
  option,
  selection,
  onClick,
}: OptionProps) {
  const [openPlace, setOpenPlace] = useState(false)

  const handleSavePlace = (place: string) => {
    const id = option.id
    onClick(id, [{ place }], "place")
    setOpenPlace(false)
  }

  const handleAddPlace = () => {
    setOpenPlace(true)
  }

  const handleClosePlace = () => {
    setOpenPlace(false)
  }

  const el: Selected[] = []
  const places: Selected[] = selection.filter(
    (el: Selected) => el.category_type === "place"
  )

  for (let place of places) {
    if (option.id === place.id) el.push(place)
  }

  const values = el.length > 0 ? el[0].value : []

  const sharedStyles = useSafetyPlanOptionStyles()
  const localStyles = useStyles()
  const classes = { ...sharedStyles, ...localStyles }

  return (
    <>
      {values.map((item: any, index: number) => (
        <div className={classes.placeContainer} key={index.toString()}>
          <Typography className={classes.optionUserAddedTxt}>
            {item.place}
          </Typography>
          <FontAwesomeIcon icon={faLocationDot} className={classes.plusColor} />
        </div>
      ))}
      <Button onClick={handleAddPlace} className={classes.addPlaceModalBtn}>
        <FontAwesomeIcon icon={faLocationDot} className={classes.plusColor} />
        <Typography className={classes.addPlaceDialogActionTxt}>
          Add a Place
        </Typography>
      </Button>
      <AddPlaceDialog
        open={openPlace}
        onClose={handleClosePlace}
        onSave={handleSavePlace}
      />
    </>
  )
}

const useStyles = makeStyles(() => ({
  placeContainer: {
    display: "flex",
    minHeight: "52px",
    padding: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "4px",
    background: "rgba(0, 0, 0, 0.03)",
  },
  optionUserAddedTxt: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "20px",
    color: colors.primary.midnight,
    flex: "1 0 0",
    textAlign: "center",
  },
}))
